/**
 * Whether a saved contact address should auto-assign to a transaction line whose
 * counterparty is `address` on `lineNetworkId`.
 *
 * EVM-style addresses are identical across chains, so an address-only match lets a
 * contact saved for one chain (e.g. Arbitrum) land on a transaction on another chain
 * (e.g. Ethereum). When both sides know their network, the networks must agree.
 * Contact addresses saved without a network, and lines whose network is unknown,
 * keep the legacy address-only match so existing auto-assignments don't disappear.
 */
export function contactAddressMatchesLine(
  contactAddress: { address: string; networkId?: string | null },
  address: string | null | undefined,
  lineNetworkId: string | null | undefined
): boolean {
  if (contactAddress.address !== address) return false;
  if (!contactAddress.networkId || !lineNetworkId) return true;
  return contactAddress.networkId.toLowerCase() === lineNetworkId.toLowerCase();
}
